// extracted by mini-css-extract-plugin
module.exports = {"item":"Style_item__39JAx","title":"Style_title__AlUKm","detail":"Style_detail__1Ui5b","options":"Style_options__3hV5U"};